import PageContainer from '@/common/components/PageContainer'
import useQueryGetLoginAnnouncement from '@/modules/client-setting/api/hooks/useQueryGetLoginAnnouncement'
import LoginAnnounceListing from '@/modules/client-setting/components/LoginAnnounce/components/LoginAnnounceListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function LoginAnnouncePage() {
	const { data, isLoading } = useQueryGetLoginAnnouncement()

	return (
		<PageContainer>
			<LoginAnnounceListing data={data?.data || []} isLoading={isLoading} />
		</PageContainer>
	)
}

const GuardedLoginAnnouncePage = withUserPermission(LoginAnnouncePage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedLoginAnnouncePage
